const getDataStatus = state => state.dataStatus;
const getIsOpen = state => state.isOpen;
const getConversationId = state => state.conversation && state.conversation.conversationId;
const getConversation = state => state.conversation;
const getParticipants = state => state.participants;
const getMessages = state => state.messages;
const getTranscript = state => state.transcript;

export default {
  getDataStatus,
  getIsOpen,
  getConversationId,
  getConversation,
  getParticipants,
  getMessages,
  getTranscript,
};
